import React, { Component } from 'react';
import cloneDeep from 'lodash.clonedeep';

export class PopupController extends Component {
	constructor(props) {
		super(props);
		this.animatingOut = false;
		this.state = {
			components: []
		};
		this.myRefs = {};
	}

	show = (component, props) => {
		if (!props) props = {};
		let components = this.state.components;
		props.show = true;
		let state = cloneDeep(this.state);
		for (let i in state.components) {
			if (state.components[i].component === component || state.components[i].component === component.constructor) {
				return;
			}
		}
		components.push({ component, props });
		this.setState({ components });
	};

	_matchComponent = (component1, component2) => {
		if (!component1) return false;
		if (!component2) return false;
		if (component1 === component2) return true;
		if (component1 === component2.constructor) return true;
		return false;
	};

	hide = (component) => {
		let state = cloneDeep(this.state);
		if (this.animatingOut) {
			return setTimeout(() => {
				this.hide(component);
			}, 450);
		}
		this.animatingOut = true;
		for (let i in state.components) {
			if (this._matchComponent(state.components[i].component, component)) {
				// eslint-disable-next-line
				state.components[i].props.show = false;
				setTimeout(() => {
					state.components.splice(i, 1);
					this.animatingOut = false;
					this.setState(state);
				}, 400);
			}
		}
		this.setState(state);
	};

	_components = () => {
		let comps = [];
		for (let i in this.state.components) {
			let component = this.state.components[i];
			let props = this.state.components[i].props;
			comps.push(
				<component.component
					onPopupClosed={() => {
						this.hide(component.component);
					}}
					key={i}
					ref={(ref) => {
						this.myRefs[i] = ref;
					}}
					onClose={() => {
						this.hide(component.component);
					}}
					{...props}
				/>
			);
		}
		if (comps.length > 0) return comps;
		return null;
	};

	getValue = () => {
		return this.popup.getValue();
	};

	render() {
		return this._components();
	}
}



// WEBPACK FOOTER //
// ./src/components/popupController/PopupController.jsx